export default __webpack_public_path__ + "static/media/bowie57.21aef213.webp";